<script>
export default {
  data() {
    return {
      name: '',
      picker: '',
    };
  },
};
</script>

<template>
  <div class="filter-edit-entities">
    Not implemented yet.
  </div>
</template>

<style lang="scss">
  .filter-edit-entities {
    height: calc(100vh - 114px);
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FilterEditEntities.vue